<app-header></app-header>
<ion-content scroll-y="false">
  <div
    class="preferences-content gray-content-bg"
    #mainDivScroll
    *ngIf="vm$ | async; let vm"
  >
    <ion-header
      class="payment-preferences-header"
      data-cy="payment-preferences-header"
      *ngIf="platformService?.platformType === platformService?.platformEnum.desktop"
    >
      <ion-grid>
        <ion-row>
          <ion-col size="12">
            <app-breadcrumbs [breadcrumbs]="vm.breadcrumbs"></app-breadcrumbs>
          </ion-col>
        </ion-row>
        <ion-row
          class="header__title-row"
          [ngClass]="{'is-windows': platformService?.isWindows(), 'is-tablet': platformService?.platformType === platformService?.platformEnum.tablet }"
        >
          <ion-col size="12">
            <h1 class="page-title-oswald" data-cy="title-text">
              {{'i18n.payments.paymentPreferences.title'| translate}}
            </h1>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="filter-reset-section-desktop" size="12">
            <ion-button
              class="usf-outline-green-button open-filters"
              data-cy="open-filters-button"
              fill="usf-outline-green-button"
              (click)="openFilterModal()"
            >
              <ion-icon slot="start" name="filter"></ion-icon>
              {{ 'i18n.common.filter' | translate }}
              <ng-container *ngIf="vm.filterCount">
                ({{ vm.filterCount }})
              </ng-container>
            </ion-button>
            <span
              class="clear-filters-button"
              data-cy="clear-filters-button"
              (click)="resetFilters()"
              >{{ 'i18n.common.clearAll' | translate }}</span
            >
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-header>
    <ion-header
      class="payment-preferences-header"
      data-cy="payment-preferences-header"
      *ngIf="platformService?.platformType === platformService?.platformEnum.tablet"
    >
      <ion-grid [fixed]="true">
        <ion-row
          class="header__title-row"
          [ngClass]="{'is-windows': platformService?.isWindows(), 'is-tablet': platformService?.platformType === platformService?.platformEnum.tablet }"
        >
          <ion-col size="12">
            <h1 class="page-title-oswald" data-cy="title-text">
              {{'i18n.payments.paymentPreferences.title'| translate}}
            </h1>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col size="12">
            <div class="filter-reset-section-touch">
              <ion-button
                class="usf-outline-green-button open-filters"
                data-cy="open-filters-button"
                fill="usf-outline-green-button"
                (click)="openFilterModal()"
              >
                <ion-icon slot="start" name="filter"></ion-icon>
                {{ 'i18n.common.filter' | translate }}
                <ng-container *ngIf="vm.filterCount">
                  ({{ vm.filterCount }})
                </ng-container>
              </ion-button>
              <span
                class="clear-filters-button"
                data-cy="clear-filters-button"
                (click)="resetFilters()"
                >{{ 'i18n.common.clearAll' | translate }}</span
              >
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-header>
    <ion-header
      class="payment-preferences-header"
      data-cy="payment-preferences-header"
      *ngIf="platformService?.platformType === platformService?.platformEnum.mobile"
    >
      <ion-grid [fixed]="true">
        <ion-row>
          <ion-col size="12">
            <div class="filter-reset-section-touch">
              <ion-button
                class="usf-fill-green-button open-filters"
                data-cy="open-filters-button"
                fill="usf-fill-green-button"
                (click)="openFilterModal()"
              >
                <ion-icon slot="start" name="filter"></ion-icon>
                {{ 'i18n.common.filter' | translate }}
                <ng-container *ngIf="vm.filterCount">
                  ({{ vm.filterCount }})
                </ng-container>
              </ion-button>
              <span
                class="clear-filters-button"
                data-cy="clear-filters-button"
                (click)="resetFilters()"
                >{{ 'i18n.common.clearAll' | translate }}</span
              >
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-header>
    <ion-grid class="content gray-content-bg">
      <ng-container *ngIf="vm.isLoading; else content">
        <div class="loading-title">
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
          <ion-skeleton-text class="item" animated></ion-skeleton-text>
        </div>
        <ion-skeleton-text class="item" animated></ion-skeleton-text>
        <ion-skeleton-text class="item" animated></ion-skeleton-text>
        <ion-skeleton-text class="item" animated></ion-skeleton-text>
        <ion-skeleton-text class="item" animated></ion-skeleton-text>
        <ion-skeleton-text class="item" animated></ion-skeleton-text>
        <ion-skeleton-text class="item" animated></ion-skeleton-text>
        <ion-skeleton-text class="item" animated></ion-skeleton-text>
      </ng-container>
      <ng-template #content>
        <ng-container
          *ngIf="vm.autopayBankAccounts.length > 0 || vm.manualDeductBankAccounts.length > 0; else noData"
        >
          <ion-accordion-group
            [animated]="false"
            [multiple]="vm.autopayBankAccounts.length < 50 && vm.manualDeductBankAccounts.length < 50"
            [value]="vm.autopayBankAccounts.length < 50 && vm.manualDeductBankAccounts.length < 50 ? ['autopay','bankAccounts']:vm.autopayBankAccounts.length >= 50 || vm.manualDeductBankAccounts.length >= 50? ['autopay']:[]"
          >
            <app-bank-accounts-to-deduct
              class="autopay-section"
              [bankAccounts]="vm.autopayBankAccounts"
              [isAutopay]="true"
              [canCollapseAccordion]="vm.autopayBankAccounts.length >= 50 || vm.manualDeductBankAccounts.length >= 50"
              [isAutopayEnabled]="vm.isAutopayEnabled"
              [canRemove]="vm.userCanModifyPaymentPreferences"
              [isDesktop]="platformService?.platformType === platformService?.platformEnum.desktop"
              [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
              [sortFilter]="vm.sorts[0]"
              [isEligleAutopayCustomers]="vm.isEligleAutopayCustomers"
              (actionButtonEmitter)="handleAutopaySetup($event)"
              (editButtonEmit)="openAutopayEdit(vm.userCanModifyPaymentPreferences, $event)"
              (removeButtonEmit)="removeBankAccount($event)"
              (sortFieldEmit)="setSortField($event)"
            ></app-bank-accounts-to-deduct>

            <app-bank-accounts-to-deduct
              [bankAccounts]="vm.manualDeductBankAccounts"
              [canCollapseAccordion]="vm.autopayBankAccounts.length >= 50 || vm.manualDeductBankAccounts.length >= 50"
              [canRemove]="vm.userCanModifyPaymentPreferences"
              [isAutopay]="false"
              [isDesktop]="platformService?.platformType === platformService?.platformEnum.desktop"
              [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
              [sortFilter]="vm.sorts[0]"
              (actionButtonEmitter)="openBankAccountModal(vm.userCanModifyPaymentPreferences)"
              (editButtonEmit)="openBankAccountModal(vm.userCanModifyPaymentPreferences, $event)"
              (removeButtonEmit)="removeBankAccount($event)"
              (sortFieldEmit)="setSortField($event)"
            ></app-bank-accounts-to-deduct>
          </ion-accordion-group>
        </ng-container>
      </ng-template>

      <ng-template #noData>
        <div class="empty-state-container">
          <app-empty-states
            [title]="'i18n.payments.paymentPreferences.noBankAccounts' | translate"
            [buttons]="[
            {
              text:
                'i18n.payments.paymentPreferences.autopayAction'
              | translate,
              action: handleAutopaySetup,
              params: [vm.isAutopayEnabled],
              color: 'usf-fill-green-button',
              iconSrc: !vm.isAutopayEnabled
                ? 'assets/icon/external-link-white.svg'
                : '',
            },
            {
              text:
                'i18n.payments.paymentPreferences.bankAccountsAction'
              | translate,
              action: openBankAccountModal,
              params: [vm.userCanModifyPaymentPreferences],
              color: 'usf-outline-green-button',
            },
          ]"
          ></app-empty-states>
        </div>
      </ng-template>
    </ion-grid>
    <app-footer></app-footer>
  </div>
</ion-content>

<app-top-button
  [mainScroll]="mainScroll"
  [isMobile]="platformService?.platformType === platformService?.platformEnum.mobile"
></app-top-button>
